import React, { Component } from 'react';

import { createBrowserHistory } from 'history';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import { SnackbarProvider } from 'notistack';
import { COOKIE_NAME, getCookie } from './utils';
import store from './store';

import Routes from './routes';
import theme from './theme';
import './assets/scss/index.css';
import jwt from 'jsonwebtoken';
import { setCurrentUser } from './actions';
import { Provider } from 'react-redux';

const browserHistory = createBrowserHistory();

if (
	document.cookie
		.split(';')
		.filter(item => item.trim().startsWith(`${COOKIE_NAME}=`)).length
) {
	const decodedToken = jwt.verify(getCookie(COOKIE_NAME), 'KETPETCARROTTECH');

	const currentTime = Date.now() / 1000;
	if (decodedToken.exp < currentTime) {
		store.dispatch(setCurrentUser(null));
	} else {
		store.dispatch(setCurrentUser(decodedToken));
	}
}

class App extends Component {
	render() {
		return (
			<Provider store={store}>
				<ThemeProvider theme={theme}>
					<SnackbarProvider maxSnack={3}>
						<HashRouter history={browserHistory}>
							<Routes />
						</HashRouter>
					</SnackbarProvider>
				</ThemeProvider>
			</Provider>
		);
	}
}

export default App;
